import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=61b51b36&scoped=true"
import script from "./privacy.vue?vue&type=script&lang=js"
export * from "./privacy.vue?vue&type=script&lang=js"
import style0 from "./privacy.vue?vue&type=style&index=0&id=61b51b36&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b51b36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61b51b36')) {
      api.createRecord('61b51b36', component.options)
    } else {
      api.reload('61b51b36', component.options)
    }
    module.hot.accept("./privacy.vue?vue&type=template&id=61b51b36&scoped=true", function () {
      api.rerender('61b51b36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/printingPage/sepecialOrderPrint/components/privacy.vue"
export default component.exports